var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showMore)?_c('button',{on:{"click":function($event){_vm.showMore = true}}},[_vm._v("Learn more")]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }